import React, { FC } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  }),
);

type Severity = 'error' | 'warning' | 'info' | 'success';

interface SimpleAlertProps {
  text: string;
  severity?: Severity;
}
const SimpleAlert: FC<SimpleAlertProps> = ({ text, severity = 'info' as Severity }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Alert severity={severity}>{text}</Alert>
    </div>
  );
};

export default SimpleAlert;